export const iconFontAwesomeReligionStarAndCrescent = (
	<i className="fa-solid fa-star-and-crescent"></i>
);
